import { downgradeInjectable } from '@angular/upgrade/static';
import { OidcService } from '@fry-it/risr-core';

(function() {
  'use strict';

  angular.module('blocks.auth')
    .service('OidcService', downgradeInjectable(OidcService));
})();
